<template>
  <el-card
    v-loading="loading"
    class="card-container"
    shadow="never"
  >
    <el-row
      v-if="orgInfo"
      slot="header"
      type="flex"
      justify="space-between"
      align="middle"
    >
      <el-row
        type="flex"
        align="middle"
      >
        <img
          class="org-logo"
          :src="orgInfo.avatar_url"
          alt=""
        >
        <div class="ml-m">
          <h3 class="m-0">
            {{ orgInfo.summary }}
          </h3>
          <p class="m-0 mt-xs">{{ orgInfo.description }}</p>
        </div>
      </el-row>
      <div>
        <el-row
          type="flex"
          justify="center"
        >
          <el-button
            type="primary"
            size="small"
            icon="el-icon-edit"
            @click="() => formVisible = true"
          >
            Chỉnh sửa
          </el-button>
          <el-button
            type="danger"
            size="small"
            icon="el-icon-delete"
            @click="handleDelete"
          >
            Xóa
          </el-button>
        </el-row>
      </div>
    </el-row>
    <el-row
      v-if="orgInfo"
      :gutter="12"
    >
      <el-col
        :lg="24"
        :span="24"
        class="mb-m"
      >
        <Roles
          :org-info="orgInfo"
          @changeRoleTotal="changeRoleTotal"
        />
      </el-col>
      <el-col
        :lg="24"
        :span="24"
        class="h-100 mb-m"
      >
        <Accounts
          :org-info="orgInfo"
          :role-total="roleTotal"
        />
      </el-col>
    </el-row>
    <DataFormPopup
      v-if="formVisible"
      :item="orgInfo"
      :visible="formVisible"
      @close="formVisible = false"
      @reload="loadData"
    />
  </el-card>
</template>

<script>
import Roles from "../roles/index.vue";
import Accounts from "./components/detail/Accounts.vue";
import DataFormPopup from "./popups/DataForm.vue";

import organizationServices from "@/services/organization";
import { notification } from "@/utils/common";

export default {
  name: "ConfigDetail",
  components: {
    Roles,
    Accounts,
    DataFormPopup
  },
  data() {
    return {
      loading: false,
      formVisible: false,
      orgInfo: null,
      roleTotal: 0
    };
  },
  beforeMount() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      organizationServices
        .fetchById(this.$route.params.id)
        .then((response) => {
          this.orgInfo = response;
          this.loading = false;
        })
        .catch(() => {
          this.$router.push({ name: "Organizations" });
        });
    },
    changeRoleTotal(value) {
      this.roleTotal = value;
    },
    handleDelete(item) {
      this.$confirm(`Bạn có chắc chắn muốn xoá không?`, "Xác nhận", {
        confirmButtonText: "Xoá",
        cancelButtonText: "Huỷ",
        type: "warning",
      }).then(() => {
        organizationServices
          .remove(item)
          .then(() => {
            this.$router.push({ name: "Organizations" })
            notification(this, "success", "delete", "tổ chức");
          })
          .catch(() => {
            notification(this, "error", "delete", "tổ chức");
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.org-logo {
  width: 64px;
  height: 48px;
  border-radius: 8px;
  object-fit: cover;
  cursor: pointer;
  border: 1px solid #409eff;
}
</style>
